import { createSlice } from '@reduxjs/toolkit';

const initialState = {
// SNACKBAR
  alertopen: false,
  alertmessage: '',
  alertseverity: 'info',
  alertduration: 3000,

  // DIALOG
  dialogOpen: false,
  dialogtitle: '',
  dialogcontent: '',
  dialogOnConfirm: null,
};

const uiComponentSlice = createSlice({
  name: 'uiComponents',
  initialState,
  reducers: {
    // SNACKBAR
    openSnackbarAction: (state, action) => {
      state.alertopen = true;
      state.alertmessage = action.payload.message;
      state.alertseverity = action.payload.severity || 'info';
      state.alertduration = action.payload.duration || 3000;
    },
    closeSnackbarAction: (state) => {
      state.alertopen = false;
    },
    // DIALOG
    openDialog: (state, action) => {
      state.dialogOpen = true;
      state.dialogtitle = action.payload.title;
      state.dialogcontent = action.payload.content;
      state.dialogOnConfirm = action.payload.onConfirm;
    },
    closeDialog: (state) => {
      state.dialogOpen = false;
    },
  },
});

export const {
  openSnackbarAction, closeSnackbarAction, openDialog, closeDialog
} = uiComponentSlice.actions;
export default uiComponentSlice.reducer;
